import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { BankAccountDetailsForm } from "./BankAccountDetailsForm";
import {
  SheetTabsContainer,
  SheetTabsContent,
  SheetTabsList,
} from "@common/components";

const SheetTabs = [
  {
    name: "Account Details",
    value: "accountDetails",
  },
];
interface Props {
  onClose: () => void;
}

export const BankAccountDetailsContent = ({ onClose }: Props) => {
  return (
    <>
      <SheetHeader>
        <SheetTitle>Link Bank Account</SheetTitle>
      </SheetHeader>
      <SheetTabsContainer defaultValue="accountDetails">
        <SheetTabsList tabs={SheetTabs} />
        <SheetTabsContent value="accountDetails">
          <BankAccountDetailsForm onClose={onClose} />
        </SheetTabsContent>
      </SheetTabsContainer>
    </>
  );
};
